// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"37b4d097","67":"a2432d1d","323":"05aad085","333":"a06be5eb","447":"8e056456","461":"5cacc246","487":"a5a1e031","490":"062cec35","511":"83fa5bae","534":"bfda9b03","563":"2bb4d203","794":"6edbdc66","859":"84a8669e","896":"0e98da44"}[chunkId] + ".chunk.js";
};